// Full-document render of the sealy ReviewsPage: PageSkeleton (the React
// document shell) wrapping the love-root hub header + breadcrumb (rendered
// only when the page sits under a CustomerContentHubRootPage), the existing
// reviews-page body assembly, and the shared reviews SPA.
import React from "react";

import { templates } from "@reactivated";

import { CustomerContentHubHeader } from "../apps/customer-content-hub/CustomerContentHubHeader";
import { PageSkeleton } from "../components/PageSkeleton";
import { ReviewsPageBody } from "../components/ReviewsPageBody";
import { Template as ReviewsSPA } from "./ReviewsPageTemplate";

// Mutable reactivated props (not Immutable<>): this template composes the
// in-tree SiteHeader/RichNavigation chain via PageSkeleton, which is typed
// with mutable reactivated props (see PageSkeleton). The body template accepts
// Immutable props, to which these are assignable.
export const Template = (
    props: templates.ReviewsPageDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        {props.love_root && (
            <>
                <CustomerContentHubHeader love_root={props.love_root} />
                <div className="l-full-width">
                    <div className="l-capped-width">
                        <article className="sub-nav">
                            <nav className="breadcrumb" aria-label="Breadcrumb">
                                <ul className="breadcrumb__list">
                                    <li className="breadcrumb__list-item">
                                        <a href={props.love_root.url}>
                                            {props.love_root.title}
                                        </a>
                                    </li>
                                    <li
                                        className="breadcrumb__list-item"
                                        aria-current="page"
                                    >
                                        <a> {props.page.title}</a>
                                    </li>
                                </ul>
                            </nav>
                        </article>
                    </div>
                </div>
            </>
        )}
        <ReviewsPageBody page={props.page} />
        <div className="customer-review">
            <section className="all-reviews l-capped-width">
                <ReviewsSPA {...props} />
            </section>
        </div>
    </PageSkeleton>
);
